import { render, staticRenderFns } from "./host.vue?vue&type=template&id=9fbd9608&scoped=true"
import script from "./host.vue?vue&type=script&lang=js"
export * from "./host.vue?vue&type=script&lang=js"
import style0 from "./host.vue?vue&type=style&index=0&id=9fbd9608&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbd9608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fbd9608')) {
      api.createRecord('9fbd9608', component.options)
    } else {
      api.reload('9fbd9608', component.options)
    }
    module.hot.accept("./host.vue?vue&type=template&id=9fbd9608&scoped=true", function () {
      api.rerender('9fbd9608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/host.vue"
export default component.exports